/*
 * This is a wrapper function in case we want to add more rendering exceptions in the future.
 * For the moment I'm only applying it to the 'exists' '!exists' string filters comparison which don't need any value in the backend.
 */
export const renderStringFilterValue = (filter: string): boolean => {
  return !isExistStringFilterComparison(filter);
};

export const isExistStringFilterComparison = (filterOption: string): boolean => {
  return filterOption === 'exists' || filterOption === '!exists';
};
